export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-building-2-line text-primary-600 text-sm"></i>
              <span className="text-primary-700 text-xs font-medium">品牌故事</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              关于我们
            </h2>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex-1">
                <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                  <strong className="text-foreground-900 font-heading">麻花影院</strong>创立于对极致观影体验的不懈追求。
                  我们深知，真正的电影魅力在于每一个细节——从演员微妙的表表情变化到导演精心设计的画面构图，
                  只有<strong className="text-foreground-900">超清4K画质</strong>才能完整呈现这些银幕上的艺术表达。
                </p>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  平台目前已收录<strong className="text-foreground-900">超过12,000部</strong>高清影片，
                  涵盖动作、科幻、剧情、悬疑、动画等全类型内容。我们的内容团队每天都在精心甄选和更新片库，
                  依托全球68个CDN节点和第五代画质引擎，为每位影迷提供<strong className="text-foreground-900">蓝光画质、流畅不卡</strong>的观影体验。
                </p>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  从经典华语电影的4K修复到最新院线大片的超清呈现，麻花影院始终坚持一个信念：
                  让每一位观众都能在自己喜欢的设备上，以最清晰的画质、最流畅的体验，享受电影带来的感动与震撼。
                  观影不止是消遣，更是通往另一个世界的窗口。
                </p>
              </div>

              <div className="flex flex-col gap-4 flex-shrink-0 w-full md:w-56">
                <div className="bg-primary-100/60 rounded-xl p-5 text-center">
                  <div className="text-primary-700 font-heading text-3xl font-bold">12,000+</div>
                  <div className="text-primary-600 text-xs mt-1">高清影片</div>
                </div>
                <div className="bg-accent-100/60 rounded-xl p-5 text-center">
                  <div className="text-accent-700 font-heading text-3xl font-bold">4K HDR</div>
                  <div className="text-accent-600 text-xs mt-1">超清画质</div>
                </div>
                <div className="bg-secondary-100/60 rounded-xl p-5 text-center">
                  <div className="text-secondary-700 font-heading text-3xl font-bold">68</div>
                  <div className="text-secondary-600 text-xs mt-1">全球CDN节点</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}